import { CSSProperties } from "react";

export const styleName: CSSProperties = {
	fontFamily: 'Open Sans',
	fontSize: 12,
	marginRight: '4px',
};

export const styleValue: CSSProperties = {
	fontFamily: 'Open Sans',
	fontSize: 14,
	fontWeight: 700,
};

export const styleContainer: CSSProperties = {
	width: '100%',
	height: '100%',
	display: 'flex',
	flexDirection: 'column',
	gap: 5,
	alignItems: 'center',
	justifyContent: 'space-around',
	paddingTop: 10,
	paddingBottom: 10,
};

export const styleForeignObject: CSSProperties = {
	background: 'white',
	border: '1px solid #9C9C9C',
	gap: 10,
	alignItems: 'center',

};
